var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTextCompare = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  id: "text_compare"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_0_193",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "Bounding box",
  width: 20,
  height: 20,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_0_193)"
}, /*#__PURE__*/React.createElement("path", {
  id: "text_compare_2",
  d: "M8.33333 19.1667V17.5H4.16667C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H8.33333V0.833333H10V19.1667H8.33333ZM4.16667 15.8333H8.33333V14.1667H5.83333V12.5H8.33333V10.8333H5.83333V9.16667H8.33333V7.5H5.83333V5.83333H8.33333V4.16667H4.16667V15.8333ZM11.6667 4.16667V2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H11.6667V15.8333H15.8333V4.16667H11.6667ZM11.6667 10.8333V9.16667H14.1667V10.8333H11.6667ZM11.6667 7.5V5.83333H14.1667V7.5H11.6667Z",
  fill: "#1C1B1F"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextCompare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/text-compare.3967b8158a3a84b597cbcac07bacf7d1.svg";